import { render, staticRenderFns } from "./VCWeeklyProdutionSummary.vue?vue&type=template&id=44653468"
import script from "./VCWeeklyProdutionSummary.vue?vue&type=script&lang=js"
export * from "./VCWeeklyProdutionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports